
export enum ShippingTypeEnum {
  None = 0,
  Air = 1,
  Sea = 2
}
